import { useSelector } from 'react-redux';

import Global from '../../store/global-selectors';
import { useDeriveSubscriptionInfo } from '../../pages/settings/payment-and-subscription/hooks/use-derive-subscription-info';
import { FeatureFlagDeclarations } from '../feature-flag-declarations';
import { useFeatureFlag } from './use-feature-flag';
import { useAddOnsFeatureGate } from '../../feature-gates/use-addons-feature-gate';
import { UserPermissionService } from '../../services/user-permission-service';

export const useEnableAddOnCentral = () => {
  const planInfo = useSelector(Global.selectSellerPlanInfo);
  const userRoles = useSelector(Global.selectUseruserRoles);
  const userRolePermission = UserPermissionService.userHasConfigurationRole(userRoles);
  const { isPlanLocked = false } = planInfo || {};
  const { isTrialAccount, hasActivePaidPlan } = useDeriveSubscriptionInfo(planInfo);
  const { isAddOnsFeatureEnabled } = useAddOnsFeatureGate();

  const isTrial = isTrialAccount && !hasActivePaidPlan;
  const isCTPPlan = !isTrial && isPlanLocked;
  const isAddOnCentralEnabled = useFeatureFlag(FeatureFlagDeclarations.enableAddOnCentral);
  return isAddOnCentralEnabled && !isCTPPlan && userRolePermission && isAddOnsFeatureEnabled;
};
